import React from 'react';

import { Button } from '@/components/ui/button';

interface DeleteConfirmRowProps {
  onConfirm: () => void;
  onCancel: () => void;
  disabled: boolean;
  isDeleting: boolean;
}

export const DeleteConfirmRow: React.FC<DeleteConfirmRowProps> = ({
  onConfirm,
  onCancel,
  disabled,
  isDeleting,
}) => (
  <div className="flex items-center gap-2">
    <span className="text-chariot-status-warning text-sm font-medium">
      Confirm delete? Assigned assets will revert to the global default.
    </span>
    <Button
      variant="destructive"
      size="sm"
      onClick={onConfirm}
      disabled={disabled}
      data-testid="single-scan-profile-delete-confirm-button"
    >
      {isDeleting ? 'Deleting...' : 'Yes, delete'}
    </Button>
    <Button
      variant="ghost"
      size="sm"
      onClick={onCancel}
      disabled={disabled}
      data-testid="single-scan-profile-delete-cancel-button"
    >
      Cancel
    </Button>
  </div>
);
